import { Navigate, Route } from 'react-router-dom';
import Compartidas from 'sites/admin/inmobiliario/gestionarPropiedades/Compartidas';
import GestionarPropiedades from 'sites/admin/inmobiliario/gestionarPropiedades/GestionarPropiedades';
import PropertyWizard from 'sites/admin/inmobiliario/gestionarPropiedades/propertyWizard/PropertyWizard';
import MyProjects from 'sites/admin/inmobiliario/projects/MyProjects';
import SharedProjects from 'sites/admin/inmobiliario/projects/SharedProjects';
import ProjectWizard from 'sites/admin/inmobiliario/projects/projectWizard/ProjectWizard';
import { checkPermission } from 'utils/checkPermission';

const RoutesPropiedades = userLogged => {
  return (
    userLogged && (
      <>
        <Route path="/propiedades">
          <Route
            path=""
            element={
              checkPermission('Properties', userLogged) ? (
                <GestionarPropiedades />
              ) : (
                <Navigate to={'/errors/permisos'} />
              )
            }
          />
          <Route
            path="cargar"
            element={
              checkPermission('Create properties', userLogged) ? (
                <PropertyWizard create key="create" />
              ) : (
                <Navigate to={'/errors/permisos'} />
              )
            }
          />
          <Route
            path="editar/:id"
            element={
              checkPermission('Edit properties', userLogged) ? (
                <PropertyWizard key="edit" />
              ) : (
                <Navigate to={'/errors/permisos'} />
              )
            }
          />
          <Route
            path="compartidas"
            element={
              checkPermission('Shared', userLogged) ? (
                <Compartidas />
              ) : (
                <Navigate to={'/errors/permisos'} />
              )
            }
          />
        </Route>

        <Route path="/emprendimientos">
          <Route
            path=""
            element={
              checkPermission('Properties', userLogged) ? (
                <MyProjects />
              ) : (
                <Navigate to={'/errors/permisos'} />
              )
            }
          />
          <Route
            path="cargar"
            element={
              checkPermission('Create properties', userLogged) ? (
                <ProjectWizard create key="create" />
              ) : (
                <Navigate to={'/errors/permisos'} />
              )
            }
          />

          <Route
            path="editar/:id"
            element={
              checkPermission('Edit properties', userLogged) ? (
                <ProjectWizard key="edit" />
              ) : (
                <Navigate to={'/errors/permisos'} />
              )
            }
          />

          <Route
            path="compartidos"
            element={
              checkPermission('Shared', userLogged) ? (
                <SharedProjects />
              ) : (
                <Navigate to={'/errors/permisos'} />
              )
            }
          />
        </Route>
      </>
    )
  );
};

export default RoutesPropiedades;
